  <style scoped lang="scss">
    .desc-p {
    }
    .report-type-section {
        .report-type-section-inner {
            display: flex;
            flex-direction: column;
            .report-type-section-inner-detail {
                flex: 1 1 auto;
            }
        }
        ul {
            list-style: none;
            li {
                font-size: 18px;
                line-height: 24px;
            }
        }
    }
</style>

<template>
<div class="uk-form" v-if="application && application.household">
    <div class="uk-grid" v-if="!print">
        <div class="uk-width-medium-3-5 uk-push-1-5 uk-margin-large-bottom">
            <div class="uk-panel-box"><strong>Understanding Gross vs Net:</strong> <small><br class="uk-margin-bottom"/>
                Gross income is the amount you earn before deductions are subtracted for insurance, taxes, Medicare, fees etc.. Net income is how much money is left after the deductions are subtracted. For this application, please enter your gross income for ALL income types.</small>
            </div>

            <div class="uk-panel-box" v-if="programSettings['uses-same-method-income']"><strong>Everyone Must Report Income the Same Way:</strong> <small><br class="uk-margin-bottom"/>If you select 1040 as your Proof of Income Type, all members of the household 18 and over with income must also use the 1040 Proof of Income Type.  The same applies with the {{ programSettings['required-days-of-income-proof'] }} days option. <br /><br /> If you select the {{ programSettings['required-days-of-income-proof'] }} days option, then all members of the household 18 and over with income must use the {{ programSettings['required-days-of-income-proof'] }} days Proof of Income Type. <br /><br />For those 18 and over with no income, you must select the no income type and complete the questions that will appear. </small>
            </div>

        </div>
    </div>
    <div class="uk-grid uk-width-1-1">
        <div class="uk-width-1-1 uk-margin-large-bottom" v-if="shouldShowMember(member)" v-for="member in household.members" :key="member.id">
            <legend>{{ member.first_name }} {{ member.last_name }}</legend>

            <div class="uk-grid">
                <div class="uk-width-small-1-1 uk-width-medium-1-2 uk-width-large-1-3 uk-margin-bottom">
                    <label>Select {{ member.first_name }}'s Proof of Income Type</label>
                    <validated-section :field="`income_type_${member.id}`" :errors="errors">
                        <select :value="householdMembersWithIncome[member.id].incomeProofType" @change="onIncomeTypeChange($event.target.value, member.id)" class="uk-select uk-width-1-1">
                            <option :value="null">Please Make a Selection...</option>
                            <option value="1040">Last Year's 1040 (Pages 1 & 2 Only)</option>
                            <option value="w2-1099" v-if="programSettings['uses-income-history-documents']">Last Year's Proof of Income (W2 / 1099 / K-1 / etc)</option>
                            <option value="last-days">Last {{ programSettings['required-days-of-income-proof'] }} Days of Income</option>
                            <option value="none">No Income</option>
                        </select>
                    </validated-section>
                </div>

                <div class="uk-width-1-1 uk-margin-top" v-if="householdMembersWithIncome[member.id].incomeProofType === null || !householdMembersWithIncome[member.id].incomeProofType">
                    <div class="uk-grid report-type-section">
                        <div class="uk-width-medium-1-1">
                            <h2 class="uk-card-title">Using Your {{ currentYear - 1 }} Tax Filing to Report Your Income</h2>
                            <h3 class="uk-h3">Your 2020 Tax Filing is Your Best Income Reporting Option.</h3>

                            <ul>
                                <li><i class="a-circle-checked"></i> Uses Your Adjusted Gross Income</li>
                                <li><i class="a-circle-checked"></i> Certify Once</li>
                                <li><i class="a-circle-checked"></i> One Document for each Household Member 18 and over</li>
                            </ul>

                            <h3 class="uk-h3">Using your 2020 taxes allows you to use your Adjusted Gross Income (which is less than your gross income), and you only have to certify it once. All other options require you to recertify your income every 90 days.</h3>

                            <div class="uk-card-footer">
                                <button type="button" class="uk-button uk-button-primary uk-width-1-1 verify-compensation-button" @click="onTypeButtonClick(member.id, '1040')" >Yes! Let's Use My 2020 Tax Filing!</button>
                            </div>
                        </div>
                    </div>
                    <div class="uk-grid uk-margin-large-top report-type-section">
                        <div class="report-type-section-inner" :class="reportGridItemWidthClass" v-if="programSettings['uses-income-history-documents']">
                            <div class="report-type-section-inner-detail">
                                <h2 class="uk-card-title">I Haven't Filed, But I Have My 2020 W2s and 1099s</h2>
                                <h3 class="uk-h3">We highly recommend you file right away so you can take advantage of the lower Adjusted Gross Income and the single certification requirement.</h3>
                                <h3 class="uk-h3 uk-margin-top"> <a href="https://www.irs.gov/filing/free-file-do-your-federal-taxes-for-free" target="_blank">File for free here!</a></h3>
                            </div>

                            <div class="uk-card-footer">
                                <button type="button" class="uk-button uk-button-primary uk-width-1-1 verify-compensation-button" @click="onTypeButtonClick(member.id, 'w2-1099')" >Upload Proof of Income</button>
                            </div>
                        </div>
                        <div class="report-type-section-inner" :class="reportGridItemWidthClass">
                            <div class="report-type-section-inner-detail">
                                <h2 class="uk-card-title">I Only Have the Last {{ programSettings['required-days-of-income-proof'] }} Days of Income</h2>
                                <h3 class="uk-h3">This is the least recommended method. It requires the most documentation, and has to be recertified every 90 days.</h3>
                                <ul>
                                    <li><i class="a-circle-checked"></i> Uses Gross Income (May Disqualify or Put You in a Lower Priority)</li>
                                    <li><i class="a-circle-checked"></i> Requires recertification Every 90 Days</li>
                                    <li><i class="a-circle-checked"></i> Requires Multiple Documents for Each Household Member</li>
                                </ul>
                            </div>


                            <div class="uk-card-footer">
                                <button type="button" class="uk-button uk-button-primary uk-width-1-1 verify-compensation-button" @click="onTypeButtonClick(member.id, 'last-days')" >Use Last {{ programSettings['required-days-of-income-proof'] }} Days of Income Statements</button>
                            </div>
                        </div>
                        <div class="report-type-section-inner" :class="reportGridItemWidthClass">
                            <div class="report-type-section-inner-detail">
                                <h2 class="uk-card-title">I Have No Income To Report</h2>
                                <h3 class="uk-h3">If you have no income for the entire household you will need to complete the form explaining how you meet your current household expenses.</h3>
                                <h3 class="uk-h3">Claiming no income when you have income to report is fraud.</h3>
                                <h3 class="uk-h3">You must complete and sign an attestation of no income for each household member 18 and older who claims no income.</h3>
                            </div>

                            <div class="uk-card-footer">
                                <button type="button" class="uk-button uk-button-primary uk-width-1-1 verify-compensation-button" @click="onTypeButtonClick(member.id, 'none')" >I HAVE NO INCOME</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="uk-width-1-1 uk-align-center" v-if="householdMembersWithIncome[member.id].incomeProofType === '1040'">
                    <irs1040-entry-form
                            :members="household.members"
                            :member="member"
                            :label="member.first_name + ' ' + member.last_name"
                            :url="uploadUrl"
                            @includedMembersChanged="updatedIncludedMembers"
                            @updated="onMemberIncomeChanged"
                            :ref="`irs1040Form_${member.id}`"
                    ></irs1040-entry-form>
                </div>

                <div class="uk-width-1-1 uk-align-center" v-if="householdMembersWithIncome[member.id].incomeProofType === 'w2-1099' && programSettings['uses-income-history-documents']">
                    <w2-or1099-entry-form
                        @updated="onMemberIncomeChanged"
                        :member="member"
                        :label="member.first_name + ' ' + member.last_name"
                        :url="uploadUrl"
                        :ref="`w2Form_${member.id}`"
                    ></w2-or1099-entry-form>

                </div>

                <div class="uk-width-1-1 uk-align-center" v-if="householdMembersWithIncome[member.id].incomeProofType === 'last-days'">
                    <income-entry-form
                        @updated="onMemberIncomeChanged"
                        :values="householdMembersWithIncome[member.id].incomeValues"
                        :member="member"
                        :members="household.members"
                        :label="member.first_name + ' ' + member.last_name"
                        :url="uploadUrl"
                        :ref="`lastDaysForm_${member.id}`"
                    ></income-entry-form>
                </div>

                <div class="uk-width-1-1 uk-align-center" v-if="householdMembersWithIncome[member.id].incomeProofType === 'none'">
                    <NoIncomeHHForm
                        :members="household.members"
                        :member="member"
                        :label="member.first_name + ' ' + member.last_name"
                        :url="uploadUrl"
                        :ref="`noIncomeHHForm_${member.id}`"
                        @confirmSelect="onMemberIncomeSelected"
                    >
                    </NoIncomeHHForm>
                </div>
            </div>
        </div>
        <div class="uk-width-1-1 uk-margin-top" v-if="!hasHouseholdEarners && programSettings['use-expense-table-income']">
            <hr/>
            <div class="uk-grid uk-margin-top">
                <div class="uk-width-1-1">
                    <p>
                        If you declare that no one in your household receives a source of income you must provide a
                        statement on how you meet your MONTHLY living expenses:
                    </p>
                </div>
                <div class="uk-width-1-1">
                    <table class="uk-table uk-hidden-small uk-table-striped">
                        <thead>
                        <tr>
                            <th>Monthly Expense</th>
                            <th v-if="programSettings['no-income-uses-monthly-amount']">Monthly Amount</th>
                            <th>How does it get paid?</th>
                            <th v-if="programSettings['no-income-uses-contact-name']">Who pays it?</th>
                            <th v-if="programSettings['no-income-uses-contact-phone']">Contact Phone</th>
                            <th v-if="programSettings['no-income-uses-contact-email']">Contact Email</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="incomeValue in zeroIncomeValues">
                            <td>{{ incomeValue.label }}</td>
                            <td v-if="programSettings['no-income-uses-monthly-amount']">
                                <vue-numeric currency="$" v-model="incomeValue.amount" type="text"></vue-numeric>
                            </td>
                            <td>
                                <select v-model="incomeValue.method" placeholder="Select a method" class="uk-select">
                                    <option :value="null">Select a method</option>
                                    <option v-for="(label, value) in zeroIncomePaymentMethods" :value="value">{{ label }}</option>
                                </select>
                            </td>
                            <td v-if="programSettings['no-income-uses-contact-name']">
                                <input type="text" v-model="incomeValue.payer">
                            </td>
                            <td v-if="programSettings['no-income-uses-contact-phone']">
                                <input type="text" v-model="incomeValue.payer_phone">
                            </td>
                            <td v-if="programSettings['no-income-uses-contact-email']">
                                <input type="text" v-model="incomeValue.payer_email">
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <div class="uk-grid uk-width-small-1-1 uk-hidden-medium uk-hidden-large uk-form uk-form-horizontal uk-form-stacked" v-for="incomeValue in zeroIncomeValues">
                        <div class="uk-width-1-1">
                            <h4>
                                {{ incomeValue.label }}
                            </h4>
                        </div>
                        <div class="uk-width-1-2 uk-margin-top uk-margin-bottom">
                            <div class="uk-form-row" v-if="programSettings['no-income-uses-monthly-amount']">
                                <label class="uk-form-label" for="">Monthly Amount</label>
                                <div class="uk-form-controls">
                                    <div>
                                        <vue-numeric currency="$" v-model="incomeValue.amount" type="text"></vue-numeric>
                                    </div>
                                </div>
                            </div>
                            <div class="uk-form-row" v-if="programSettings['no-income-uses-contact-name']">
                                <label class="uk-form-label" for="">Who pays it?</label>
                                <div class="uk-form-controls">
                                    <div>
                                        <input type="text" v-model="incomeValue.payer">
                                    </div>
                                </div>
                            </div>
                            <div class="uk-form-row" v-if="programSettings['no-income-uses-contact-phone']">
                                <label class="uk-form-label" for="">Contact Phone</label>
                                <div class="uk-form-controls">
                                    <div>
                                        <input type="text" v-model="incomeValue.payer_phone">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="uk-width-1-2 uk-margin-top uk-margin-large-bottom">
                            <div class="uk-form-row">
                                <label class="uk-form-label" for="">How?</label>
                                <div class="uk-form-controls">
                                    <select v-model="incomeValue.method" placeholder="Select a method" class="uk-select">
                                        <option :value="null">Select a method</option>
                                        <option v-for="(label, value) in zeroIncomePaymentMethods" :value="value">{{ label }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="uk-form-row" v-if="programSettings['no-income-uses-contact-email']">
                                <label class="uk-form-label" for="">Contact Email</label>
                                <div class="uk-form-controls">
                                    <div>
                                        <input type="text" v-model="incomeValue.payer_email">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="uk-width-1-1">
                    <p>Under penalty of perjury, I certify that the information presented in this certification is true and accurate to the best of my knowledge.  I further understand that providing false representations constitutes an act of fraud. False, misleading, or incomplete information may result in the repayment of any funds received through the <b>{{ program['program_abbreviation'] }}</b> Program and other remedies available under applicable law.  I also give the <b>{{ program['agency_short_name'] }}</b> and its partners permission to obtain a copy of any tax returns from the Internal Revenue Service and to verify income and other information provided herein from other State agencies.</p>
                    <div class="uk-width-1-1 uk-margin-top" v-if="programSettings['uses-esign-whole-household-no-income']">
                        <validated-section :field="`signature_no_income_${applicant.id}`" :errors="errors">
                            <signature-box @updated="onSignatureUpdated"
                                           :user-key="applicant.id"
                                           :is-signed="signatureData[applicant.id] && signatureData[applicant.id].signed_at"
                                            :completed="signatureData[applicant.id] && signatureData[applicant.id].completed"
                                           :name="applicant.first_name + ' ' + applicant.last_name"
                                           :color="programSettings['primary-program-color']"
                            ></signature-box>
                        </validated-section>
                    </div>
                    <div class="uk-width-1-1 uk-margin-top" v-else>
                        <DocRequest
                            :applicationId="application.id"
                            :member="member"
                            :incomes="zeroIncomeValues"
                            docType="no-income-entire-hh"
                        ></DocRequest>
                    </div>
                </div>
            </div>
        </div>
        <div class="uk-width-1-1 uk-margin-large-top">
            <h2 class="uk-text-right">Total Annualized Household Income: {{ totalRequested | formatMoney }}</h2>
        </div>
    </div>
    <modal-dialog
        title="Are you sure?"
        ref="confirmIncomeTypeModal"
        @close="onCloseModalConfirm"
        @confirm="onCompleteModalConfirm"
        confirmText="Confirm"
        :stuck="true"
    >
        Are you sure you want to change your income reporting method? You will lose the income information entered and it cannot be recovered.
    </modal-dialog>
</div>
</template>

<script>
    import IncomeEntryForm from "../../../../../components/AppWizard/Step3/IncomeEntryFormV4";
    import { mapState, mapGetters } from 'vuex';
    import Irs1040EntryForm from "../../../../../components/AppWizard/Step3/Irs1040EntryForm";
    import W2Or1099EntryForm from "../../../../../components/AppWizard/Step3/W2Or1099EntryForm";
    import NoIncomeHHForm from "../../../../../components/AppWizard/Step3/NoIncomeHHForm";
    import ModalDialog from "../../../../../components/Common/ModalDialog";
    import SignatureBox from "../../../../../components/AppWizard/SignatureBox";
    import ValidatedSection from "../../../../../components/Common/ValidatedSection";
    import DocRequest from "../../../../../components/AppWizard/Step3/DocRequest";

    export default {
        name: "Step3",
         components: {
            W2Or1099EntryForm,
            Irs1040EntryForm,
            IncomeEntryForm,
            ModalDialog,
            ValidatedSection,
            SignatureBox,
            DocRequest,
            NoIncomeHHForm,
        },
        props: {
            print: {
                default: false,
            }
        },
        data() {
            return {
                errors: {},
                signatureData: {},
                uploadUrl: "api/hope/documents",
                showTypeChangeAlertModal: false,
                primaryApplicantHasIncome: false,
                primaryApplicantIncomeValues: [],
                householdMembersWithIncome: {},
                zeroIncomePaymentMethods: {
                    gift: 'Gift',
                    loan: 'Loan',
                    other: 'Other',
                },
                zeroIncomeValues: [
                    {
                        name: 'family_clothing',
                        label: 'Family Clothing',
                        amount: 0,
                        method: null,
                        payer: '',
                        payer_phone: '',
                        payer_email: '',
                    },
                    {
                        name: 'rent',
                        label: 'Rent',
                        amount: 0,
                        method: null,
                        payer: '',
                        payer_phone: '',
                        payer_email: '',
                    },
                    {
                        name: 'utilities',
                        label: 'Utilities',
                        amount: 0,
                        method: null,
                        payer: '',
                        payer_phone: '',
                        payer_email: '',
                    },
                    {
                        name: 'internet',
                        label: 'Internet',
                        amount: 0,
                        method: null,
                        payer: '',
                        payer_phone: '',
                        payer_email: '',
                    },
                    {
                        name: 'medical-dental-care',
                        label: 'Medical / Dental Care',
                        amount: 0,
                        method: null,
                        payer: '',
                        payer_phone: '',
                        payer_email: '',
                    },
                    {
                        name: 'medications',
                        label: 'Medications & Prescriptions',
                        amount: 0,
                        method: null,
                        payer: '',
                        payer_phone: '',
                        payer_email: '',
                    },
                    {
                        name: 'phone',
                        label: 'Cell Phone / Phone',
                        amount: 0,
                        method: null,
                        payer: '',
                        payer_phone: '',
                        payer_email: '',
                    },
                    {
                        name: 'food',
                        label: 'Food',
                        amount: 0,
                        method: null,
                        payer: '',
                        payer_phone: '',
                        payer_email: '',
                    },
                ],

                hhMemberIdsIncludedInOtherDocs: {},
                incomeTypes: {
                    '1040': [ '1040' ],
                    'last-days': [ 'primary_monthly','secondary_monthly','tertiary_monthly','self_employment_monthly','service_pay','operation_business','self-employment','worker-compensation','interest','unemployment-benefit','ssi','annuities','insurance','alimony','regular_contribution','tanf','all_regular_pay' ],
                    'w2-1099': [ 'w2', 'k1', '1099-A', '1099-B', '1099-C', '1099-CAP', '1099-DIV', '1099-G', '1099-INT', '1099-K', '1099-LTC', '1099-MISC', '1099-OID', '1099-PATR', '1099-Q', '1099-R', '1099-SA' ],
                    'none': [ 'none' ]
                }
            }
        },
        watch: {
            application(newValue) {
                if(newValue.household) {
                    this.initData();
                }
            },
        },
        computed: {
            reportGridItemWidthClass() {
                if (this.programSettings['uses-income-history-documents'])
                    return 'uk-width-medium-1-3'
                return 'uk-width-medium-1-2'
            },

            currentYear() {
                return (new Date()).getFullYear()
            },

            hasHouseholdEarners() {
                let hasEarners = false;
                if(this.primaryApplicantHasIncome) {
                    hasEarners = true;
                }
                for(let i in this.householdMembersWithIncome) {
                    let member = this.householdMembersWithIncome[i];
                    if(member.incomeProofType !== null && member.incomeProofType !== 'none') {
                        hasEarners = true;
                    }
                }
                return hasEarners;
            },
            household() {
                if(this.application && this.application.household) {
                    return this.application.household;
                }
            },
            totalRequested() {
                let total = 0;
                _.each(this.householdMembersWithIncome, member => {
                    const values = member.incomeValues.filter(item => this.incomeTypes[member.incomeProofType] && this.incomeTypes[member.incomeProofType].includes(item.type))
                    _.each(values, income => {
                        total += this.getAnnualIncomeFromIncomeValue(income)
                    })
                })
                return total;
            },
            ...mapState('Application', {
                assets: state => state.assets,
                application: state => state.application,
                applicant: state => state.applicant,
                signatures: state => state.applicant.signatures,
            }),
            ...mapGetters('Application', [ 'program', 'programSettings' ]),
        },
        mounted() {
            if(this.household) {
                this.initData();
            }

        },
        methods: {
            generateZeroIncomeList() {
                this.zeroIncomeValues = _.map(this.assets.zeroIncomeTypes, type => {
                    return {
                        name: type.name,
                        label: type.label,
                        amount: 0,
                        method: null,
                        payer: '',
                        payer_phone: '',
                        payer_email: '',
                    }
                })
            },
            onSignatureUpdated($event) {
                if(!this.signatureData[$event.key]) {
                    this.$set(this.signatureData, $event.key, {});
                }
                this.$set(this.signatureData, $event.key, { signed_at: $event.isSigned ? moment().format('YYYY-MM-DD HH:mm') : null});
            },

            onCloseModalConfirm(data) {
                const {id, oldVal, newVal } = data
                setTimeout(() => {
                    this.changeProofType(id, oldVal)
                }, 100)
            },

            onCompleteModalConfirm(data) {
                const {id, oldVal, newVal } = data
                this.changeProofType(id, newVal)
            },

            onIncomeTypeChange(value, id, showModal = true) {

                if (this.householdMembersWithIncome[id].incomeProofType !== value)
                {
                    if (this.householdMembersWithIncome[id].incomeProofType && showModal)
                    {
                        this.$refs.confirmIncomeTypeModal.setData({
                            id: id,
                            oldVal: this.householdMembersWithIncome[id].incomeProofType,
                            newVal: value,
                        })

                        this.$refs.confirmIncomeTypeModal.open();
                    } else {
                        this.changeProofType(id, value)
                    }
                }
                this.$nextTick(this.$forceUpdate);
            },

            changeProofType(id, value) {
                console.log(value, id)
                this.hhMemberIdsIncludedInOtherDocs = {};
                if (this.programSettings['uses-same-method-income'] && value !== 'none')
                {
                    _.each(this.householdMembersWithIncome, (item, idx) => {
                        if (item.incomeProofType != 'none' || idx == id)
                        {
                            console.log(item.incomeProofType, idx, item)
                            item.incomeProofType = value
                        }
                    })
                } else {
                    this.householdMembersWithIncome[id].incomeProofType = value
                }
            },

            onTypeButtonClick(id, type) {
                this.changeProofType(id, type)
            },

            shouldShowMember(member) {
                const memberId = parseInt(member.id);
                let isIncluded = false;
                for(var i in this.hhMemberIdsIncludedInOtherDocs) {
                    if(this.hhMemberIdsIncludedInOtherDocs[i].includes(memberId)) {
                        isIncluded = true
                        break;
                    }
                }
                return !isIncluded && this.householdMembersWithIncome[memberId] && this.ageForMember(member) >= 18;
            },

            updatedIncludedMembers(payload) {
                if(payload.memberIds.length === 0) {
                    this.$set(this.hhMemberIdsIncludedInOtherDocs, payload.fromMember, []);
                }else {
                    if(this.hhMemberIdsIncludedInOtherDocs[payload.fromMember] === undefined) {
                        this.$set(this.hhMemberIdsIncludedInOtherDocs, payload.fromMember, []);
                    }
                    this.hhMemberIdsIncludedInOtherDocs[payload.fromMember] = payload.memberIds;
                }
            },
            initData() {
                this.generateMembersArray();
                this.generateZeroIncomeList();
                _.each(this.application.zero_income_meta, meta => {
                    _.each(this.zeroIncomeValues, value => {
                        if(meta.name === value.name) {
                            value.amount = meta.amount;
                            value.method = meta.method;
                            value.payer = meta.payer;
                            value.payer_phone = meta.payer_phone;
                            value.payer_email = meta.payer_email;
                        }
                    })
                })

                this.signatureData = {}

                const signatureFiltered = this.signatures.find(item => item.key === `no-income-entire-hh`)
                if(signatureFiltered) {
                    this.$set(this.signatureData, this.applicant.id, { signed_at: signatureFiltered.created_at, completed: true });
                }
            },

            generateMembersArray() {
                this.householdMembersWithIncome = {};
                _.each(this.household.members, member => {
                    // get age
                    let dob = moment(member.birth_date);
                    let age = moment().diff(dob, 'years');
                    if(age < 18) return;

                    this.$set(this.householdMembersWithIncome, member.id, {
                        hasIncome: member.annual_income !== null && member.annual_income > 0,
                        incomeValues: member.incomes,
                        incomeProofType: member.income_type
                    });
                })
            },

            scrollTop: function () {
                if (window.pageYOffset > 0) {
                    this.intervalId = setInterval(() => {
                        if (window.pageYOffset === 0) {
                            clearInterval(this.intervalId)
                        }
                        window.scroll(0, window.pageYOffset - 50)
                    }, 5)
                }
            },

            async validateStep() {
                let stepValid = false;

                const subFormValid = await this.checkFormValid();
                if (subFormValid) {
                    await this.save();
                    stepValid = true
                }

                this.errors = {};
                if (!this.hasHouseholdEarners && this.programSettings['uses-esign-whole-household-no-income'])
                {
                    if (this.programSettings['use-expense-table-income'])
                    {
                        if(!this.signatureData[this.applicant.id]) {
                            this.errors['signature_no_income_' + this.applicant.id] = {
                                errors: [this.applicant.first_name + ' ' + this.applicant.last_name + ' must sign this form as their name appears above.'],
                            };
                        }else if(this.signatureData[this.applicant.id] && this.signatureData[this.applicant.id].signed_at == null) {
                            this.errors['signature_no_income_' + this.applicant.id] = {
                                errors: [this.applicant.first_name + ' ' + this.applicant.last_name + ' must sign this form as their name appears above.'],
                            };
                        }
                    }
                }

                _.each(this.householdMembersWithIncome, (member, id) => {
                    const hhMember = this.household.members.find(item => item.id == id)
                    let vMember = {
                        ...member,
                        id,
                        birth_date: hhMember.birth_date
                    }
                    if(!member.incomeProofType && this.shouldShowMember(vMember))
                    {
                        const userName = hhMember ? hhMember.first_name + ' ' + hhMember.last_name : 'User'
                        this.errors['income_type_' + id] = {
                            errors: [userName + ' must select an option below.'],
                        };
                    }
                })
                console.log(this.errors);
                let errorCount = _.size(this.errors);

                if(errorCount > 0) stepValid = false;

                !stepValid &&  this.scrollTop()

                return stepValid
            },
            async save() {
                let data = {
                    application: {
                        zero_income: this.hasHouseholdEarners ? 0 : 1,
                        zero_income_meta: (this.hasHouseholdEarners) ? null : JSON.stringify(this.zeroIncomeValues),
                        signatureData: this.signatureData
                    },
                    members: this.getHouseholdMemberData(),
                }

                return axios.put(`/api/hope/applications/${this.application.id}/step-3`, data)
                    .then((res) => {
                        this.$store.dispatch('Application/fetch', this.application.id)
                    })
                    .catch((error) => {
                    })
            },

            async checkFormValid() {

                let isValid = true;
                _.each(this.householdMembersWithIncome, (member, id) => {
                    let refForm = undefined

                    switch (member.incomeProofType) {
                        case '1040':
                            refForm = this.$refs[`irs1040Form_${id}`][0]
                            break;
                        case 'w2-1099':
                            refForm = this.$refs[`w2Form_${id}`][0]
                            break;
                        case 'last-days':
                            refForm = this.$refs[`lastDaysForm_${id}`][0]
                            break;
                        case 'none':
                            refForm = this.$refs[`noIncomeHHForm_${id}`][0]
                            break;
                        default:
                            break;
                    }

                    if (refForm && typeof refForm['validate'] === 'function')
                    {
                        isValid = isValid && refForm.validate();
                    }

                });
                return isValid;
            },

            getHouseholdMemberData() {
                let data = {}
                let index = 0;
                _.each(this.householdMembersWithIncome, (member, id) => {
                    let refForm = undefined
                    let incomes = []
                    let signatureData = {}

                    switch (member.incomeProofType) {
                        case '1040':
                            refForm = this.$refs[`irs1040Form_${id}`][0]
                            incomes = refForm ? [refForm.income]: [];
                            signatureData = refForm ? refForm.signatureData: {};
                            break;
                        case 'w2-1099':
                            refForm = this.$refs[`w2Form_${id}`][0]
                            incomes = refForm ? refForm.incomes: [];
                            signatureData = refForm ? refForm.signatureData: {};
                            break;
                        case 'last-days':
                            refForm = this.$refs[`lastDaysForm_${id}`][0]
                            incomes = refForm ? refForm.incomes: [];
                            signatureData = refForm ? refForm.signatureData: {};
                            break;
                        case 'none':
                            refForm = this.$refs[`noIncomeHHForm_${id}`][0]
                            signatureData = refForm ? refForm.signatureData: {};
                            break;
                        default:
                            break;
                    }

                    data[id] = {
                        annual_income: this.getTotalRequestedForMember(member),
                        annual_income_meta: member.incomeValues,
                        incomes: incomes,
                        signatureData: signatureData,
                        ...member
                    }
                    index++;
                })
                return data;
            },

            ageForMember(member) {
                return moment().diff(moment(member.birth_date), 'years');
            },
            checkboxUpdated() {
                window.setTimeout(() => this.$forceUpdate(), 200);
                // this.$nextTick(this.$forceUpdate);
            },

            getTotalRequestedForMember(member) {
                let total = 0;
                _.each(member.incomeValues, income => {
                    total += this.getAnnualIncomeFromIncomeValue(income)
                })
                return total;
            },

            getAnnualIncomeFromIncomeValue(income) {
                let amount = income.income_amount
                let arr = ['paystub', 'attestation']
                if (arr.includes(income.doc_type))
                {
                    let incomeAssets = income.doc_type === 'paystub' ? income.paystubs : income.attestations
                    amount = _.reduce(incomeAssets, (sum, item) => {
                        return sum + item.income_amount
                    }, 0);
                    amount = incomeAssets.length ? amount / incomeAssets.length : 0;
                    switch(income.interval) {
                        case 'monthly':
                        case 'other':
                            amount = parseFloat(amount) * 12;
                            break;

                        case 'weekly':
                            amount = parseFloat(amount) * 52;
                            break;

                        case 'biweekly':
                            amount = parseFloat(amount) * 26;
                            break;

                        case 'bimonthly':
                            amount = parseFloat(amount) * 24;
                            break;

                        case 'annually':
                            amount = parseFloat(amount);
                            break;

                        default: amount = parseFloat(amount) * 12;
                            break;
                    }
                }

                return amount ? amount:  0;

            },

            getTotalRequested() {
                let total = 0;
                _.each(this.householdMembersWithIncome, member => {
                    _.each(member.incomes, income => {
                        total += this.getAnnualIncomeFromIncomeValue(income)
                    })
                })
                return total;
            },

            onMemberIncomeSelected($event) {
                let member = $event.member;
                this.onIncomeTypeChange('last-days', member.id, false)
            },

            onMemberIncomeChanged($event) {
                this.householdMembersWithIncome[$event.member.id]['incomeValues'] = $event.amounts;
                this.householdMembersWithIncome[$event.member.id]['signatureData'] = $event.signatureData ? $event.signatureData : {};
                this.$nextTick(this.$forceUpdate);
            },
            onApplicantIncomeChanged($event) {
                this.primaryApplicantIncomeValues = $event.amounts;
                this.$nextTick(this.$forceUpdate);
            },
            MonthlyTotalIncome() {
                var totalMonthlyIncome = 0;
                var monthlyGrossWagesPrimaryJob = parseInt($('#financial-information-form').find('input[name="monthly-gross-wages-primary-job"]').val());
                /// ADD IN VARS DYNAMICALLY FOR EACH APPLICANT ADDED ON SECTION 2 FOR GRAND TOTAL ///

                var monthlyGrossWagesSecondJob = parseInt($('#financial-information-form').find('input[name="monthly-gross-wages-second-job"]').val());
                var monthlyGrossWagesThirdJob = parseInt($('#financial-information-form').find('input[name="monthly-gross-wages-third-job"]').val());
                var selfEmployment = parseInt($('#financial-information-form').find('input[name="self-employment"]').val());
                var alimony = parseInt($('#financial-information-form').find('input[name="alimony"]').val());
                var socialSecurityIncome = parseInt($('#financial-information-form').find('input[name="social-security-income"]').val());
                var socialSecurityDisability = parseInt($('#financial-information-form').find('input[name="social-security-disability"]').val());
                var unemploymentCompensation = parseInt($('#financial-information-form').find('input[name="unemployment-compensation"]').val());
                var otherGovernmentAssistance = parseInt($('#financial-information-form').find('input[name="other-government-assistance"]').val());
                var retirement = parseInt($('#financial-information-form').find('input[name="retirement"]').val());
                var annuityInvestment = parseInt($('#financial-information-form').find('input[name="annuity-investment"]').val());
                var rentFromRoommate = parseInt($('#financial-information-form').find('input[name="rent-from-roommate"]').val());
                var rentalPropertyIncome = parseInt($('#financial-information-form').find('input[name="rental-property-income"]').val());
                var contributionsFromFamilyOrFriends = parseInt($('#financial-information-form').find('input[name="contributions-from-family-or-friends"]').val());
                var other = parseInt($('#financial-information-form').find('input[name="other"]').val());
                totalMonthlyIncome = monthlyGrossWagesPrimaryJob + monthlyGrossWagesSecondJob + monthlyGrossWagesThirdJob + selfEmployment + alimony + socialSecurityIncome + socialSecurityDisability + unemploymentCompensation + otherGovernmentAssistance + retirement + annuityInvestment + rentFromRoommate + rentalPropertyIncome + contributionsFromFamilyOrFriends + other;
                $('#financial-information-form').find('input[name="total-monthly-income"]').val(totalMonthlyIncome);

            }
        }
    }
</script>
